import type {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import type {
	HideAgenticWorkerResultInput,
	HideAgenticWorkerResultMutation,
} from './__generated__/HideAgenticWorkerResultMutation.graphql';
import type {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

const mutation = graphql`
	mutation HideAgenticWorkerResultMutation($input: HideAgenticWorkerResultInput!) {
		hideAgenticWorkerResult(input: $input) {
			result {
				id
				hidden
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<HideAgenticWorkerResultInput>,
	onSuccess?: RelayOnCompleted<HideAgenticWorkerResultMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<HideAgenticWorkerResultMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
